let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("arhgZ"), load("lSv1N")]).then(() => parcelRequire('8su69'));